import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=b1a03022&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Menu.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=b1a03022&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a03022",
  null
  
)

export default component.exports